module.exports = __webpack_public_path__ + "img/card3.0dc3e116.png";